import { scrollToItem } from '../inputs/scroll_on_focus';

document.arrive('.scroll-to', function(element) {
  $(element).on('click', function() {
    const $anchor = $($(this).data('scroll-to'));
    scrollToItem($anchor, null, true);
  });
});
